<template>
	<div class="wrapBox">
		<navheader :current="$route.query.current"></navheader>
		<div class="bannerBox">
			<div class="bannerCtx">
				<div class="banner-img-container">
					<img  src="../assets/images/banner1.png" class="imgsize" />
				</div>
			</div>
		</div>
		<div class="contentbox">
			<img  v-if="info.imagePath1" :src="info.imagePath1" style="width: 100%;height: 100%;">
			<div  v-html="info.memo" ref="contentBox"></div>
		</div>
		
		<footercommon :class="{'fixed-footer': isFixedFooter}" class="smallBox"></footercommon>
		<footercommon class="commonBox"></footercommon>
	</div>
</template>

<script>
	import navheader from "../components/navheader.vue";
	import footercommon from "../components/footercommon.vue";
	import {GetTalentRecruitment} from '@/api/api'
	export default{
		components: { navheader,footercommon},
		props:['current'],
		data(){
			return{
				info:{},
				isFixedFooter: false
			}
		},
		mounted() {
			this.GetData()
			window.addEventListener('resize', this.checkContentHeight)
		},
		updated() {
			this.$nextTick(() => {
				this.checkContentHeight()
			})
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkContentHeight)
		},
		methods:{
			GetData(){
				GetTalentRecruitment({guid:this.$route.query.guid,status: 1}).then(res => {
					this.info=res.data.data.rows[0]
					this.$nextTick(() => {
						this.checkContentHeight()
					})
				})
			},
			checkContentHeight() {
				// alert(1)
				if (this.$refs.contentBox) {
					const contentHeight = this.$refs.contentBox.offsetHeight
					const windowHeight = window.innerHeight
					// 如果内容高度小于窗口高度减去头部和底部的高度，则固定底部
					console.log(contentHeight,windowHeight)
					this.isFixedFooter = contentHeight < (windowHeight - 100)
				}
			}
		}
	}
</script>

<style lang="scss" scoped> 
.banner-img-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
	position: relative;
}

.imgsize{
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
}

.contentbox{
		// min-width: $commoneWidth;
		margin: 9.375rem;
		color:#3B5B59;
		line-height: 2rem;
		font-size: 1.375rem;
		text-align: justify;
		.contentItem{
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 10.625rem;
			.textbox{
				width: calc(100% - 35rem);
				.title{
					color:$baseColor;
					font-size: 2.625rem;
					font-weight: 800;
				}
				.ctx{
					margin-top: 2.3125rem;
					font-weight: 600;
				}
			}
		}
	}
	.fixed-footer {
		position: fixed;
		bottom: 0;
		width: 100%;
	}
	@media screen and (min-width: 769px) {//pc版本
		.smallBox{
			display: none;
		}
	}
	@media screen and (max-width: 768px) {//手机版本
		.bannerBox .bannerCtx{
			height: 9.8125rem;
		}
		.commonBox{
			display: none;
		}
		.imgsize{
			width: 100%;
			height: 157px;
		}
		.contentbox{
			width:100%;
			margin: 0 auto;
			font-size: 12px;
			min-height: 345px;
			color:#3B5B59;
			line-height: 20px;
			padding: 10px;
			box-sizing: border-box;
			.img {
				width: 375px!important;
				height: 157px !important;
			}
		}
	}
</style>